/** A game counts as live if it's flagged in_progress or has accumulated in-game state. */
export const isGameLive = (game: any) =>
  game.status === 'in_progress' ||
  (game.status !== 'completed' && (
    (game.currentInning && game.currentInning > 1) ||
    (game.inningLogs && Object.keys(game.inningLogs).length > 0)
  ));

/** "River City Rapids" → "RCR", "Mustangs" → "MUS", "ATL" → "ATL" */
export const abbreviateOpponent = (name: string) => {
  const trimmed = (name || '').trim();
  if (!trimmed) return '—';
  if (trimmed.length <= 4) return trimmed.toUpperCase();
  const words = trimmed.split(/\s+/).filter(Boolean);
  if (words.length > 1) return words.slice(0, 3).map(w => w[0]).join('').toUpperCase();
  return trimmed.slice(0, 3).toUpperCase();
};
